interface GetUrlWithLocaleArgs {
  locale: string
  websiteDefaultLocale?: string
  pathname: string
}

export const getPathnameWithLocale = ({
  locale,
  websiteDefaultLocale,
  pathname,
}: GetUrlWithLocaleArgs): string => {
  const normalizedPathname = pathname.replace(/^\/+/, '')

  if (!normalizedPathname) {
    return websiteDefaultLocale === locale ? '/' : `/${locale}`
  }

  return websiteDefaultLocale === locale
    ? `/${normalizedPathname}`
    : `/${locale}/${normalizedPathname}`
}
